import React from 'react';
import { companyAddresses } from '../../models/content';

/** Renders office addresses as separate bullets (Court Chambers first, then Peninsula). */
export default function V2AddressText({ addresses = companyAddresses, listClassName = 'address-list' }) {
  return (
    <ul className={listClassName}>
      {addresses.map((address) => (
        <li key={address[0]}>
          {address.map((line, lineIndex) => (
            <React.Fragment key={line}>
              {lineIndex > 0 && <br />}
              {line}
            </React.Fragment>
          ))}
        </li>
      ))}
    </ul>
  );
}
